import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { MojoDetailsWidgetComponent } from '@feature/_app_modules/mojo-details-widget/containers/mojo-details-widget.component';
import { MojoDetailsWidgetHttpService } from '@feature/_app_modules/mojo-details-widget/services/mojo-details-widget-http.service';
import { MojoDetailsWidgetFacadeService } from '@feature/_app_modules/mojo-details-widget/services/mojo-details-widget-facade.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as MojoDetailsWidgetReducers from '@feature/_app_modules/mojo-details-widget/ngrx/mojo-details-widget.reducers';
import { MojoDetailsWidgetEffects } from './ngrx/mojo-details-widget.effects';

@NgModule({
  declarations: [
    MojoDetailsWidgetComponent
  ],
  exports: [
    MojoDetailsWidgetComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('Details', MojoDetailsWidgetReducers.reducer),
    EffectsModule.forFeature([MojoDetailsWidgetEffects])
  ],
  providers: [
    MojoDetailsWidgetHttpService,
    MojoDetailsWidgetFacadeService]
})

export class MojoDetailsWidgetModule { }
